import trackingNumbersTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    trackingNumbersTable
  },
  data() {
    return {
      trackingNumbers: [],
      meta: {}
    }
  },
  created() {
    this.$setPageTitle(this.$t('trackingNumbers.index.title'))
    this.$setBreadcrumbs([
      {label: this.$t('breadcrumbs.trackingNumbers.index'), route: {}}
    ])
  },
  methods: {
    loadData(queryOptions = {}) {
      API.trackingNumbers.index(queryOptions).then(({data, meta}) => {
        this.trackingNumbers = data
        this.meta = meta
      })
    }
  }
})
